/*
 * File: getContactSummary.ts
 * Author: Austin Robinson
 * Date Created: 12/07/2025
 * Copyright (c) DrivingDoc 2025
 */
import type { GetStudentResponse } from 'api/hooks/private/users/students/GetStudent';

/**
 * Helper function to generate contact summary text
 */
export function getContactSummary(
  user: {
    user_phones?: Array<{
      tenant_id: string;
      user_id: string;
      priority: number;
      name: string | null;
      type: string;
      phone: string;
      extension: string | null;
      phone_verification_request: {
        contact_type: 'sms';
        contact_value: string;
        expires_at: string;
        status: 'pending' | 'verified';
        sent_at: string;
        verified_at: string;
      } | null;
    }>;
    email?: string | null;
  },
  parents?: GetStudentResponse['student']['parents'],
): string {
  const parts: string[] = [];

  // Count student contacts
  const studentPhones = user.user_phones?.length ?? 0;
  const studentEmail = user.email ? 1 : 0;
  const studentContacts = studentPhones + studentEmail;

  if (studentContacts > 0) {
    parts.push(`Student: ${studentContacts} contact${studentContacts > 1 ? 's' : ''}`);
  }

  // Count parent contacts
  if (parents && parents.length > 0) {
    parts.push(`${parents.length} parent${parents.length > 1 ? 's' : ''}`);
  }

  return parts.join(', ') || 'No contacts';
}
